// Copyright © 2021 Move Closer
import { getAbstractInputControlProps } from '../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapTextAreaProps = {
    ...getAbstractInputControlProps(),
    /**
     * Content for the `<label>` element.
     */
    label: {
        type: String,
        required: false
    },
    /**
     * Value for the `[rows]` attribute of the main `<textarea>` element.
     * @default 5
     */
    rows: {
        type: Number,
        required: false,
        default: 5
    }
};
